import { render, staticRenderFns } from "./SmallBasketFeeProgress.vue?vue&type=template&id=022271d0&scoped=true&"
import script from "./SmallBasketFeeProgress.vue?vue&type=script&lang=js&"
export * from "./SmallBasketFeeProgress.vue?vue&type=script&lang=js&"
import style0 from "./SmallBasketFeeProgress.vue?vue&type=style&index=0&id=022271d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022271d0",
  null
  
)

component.options.__file = "SmallBasketFeeProgress.vue"
export default component.exports